import React from 'react';
import PropTypes from 'prop-types';

export default function ClockIcon({ width = 14, height = 14, color = '#3E4146' }) {
  return (
    <svg
      role="img"
      aria-labelledby="clockIcon"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="clockIcon">Clock Icon</title>
      <path
        d="M9.00001 6.33325H7.66668V3.66659C7.66668 3.48977 7.59644 3.32021 7.47142 3.19518C7.34639 3.07016 7.17682 2.99992 7.00001 2.99992C6.8232 2.99992 6.65363 3.07016 6.52861 3.19518C6.40358 3.32021 6.33335 3.48977 6.33335 3.66659V6.99992C6.33335 7.17673 6.40358 7.3463 6.52861 7.47132C6.65363 7.59635 6.8232 7.66659 7.00001 7.66659H9.00001C9.17682 7.66659 9.34639 7.59635 9.47142 7.47132C9.59644 7.3463 9.66668 7.17673 9.66668 6.99992C9.66668 6.82311 9.59644 6.65354 9.47142 6.52851C9.34639 6.40349 9.17682 6.33325 9.00001 6.33325ZM7.00001 0.333252C5.68147 0.333252 4.39254 0.724245 3.29621 1.45679C2.19988 2.18933 1.3454 3.23052 0.840816 4.4487C0.336232 5.66687 0.20421 7.00731 0.461445 8.30052C0.718679 9.59373 1.35362 10.7816 2.28597 11.714C3.21832 12.6463 4.4062 13.2813 5.69941 13.5385C6.99262 13.7957 8.33306 13.6637 9.55124 13.1591C10.7694 12.6545 11.8106 11.8 12.5431 10.7037C13.2757 9.60739 13.6667 8.31846 13.6667 6.99992C13.6667 6.12444 13.4942 5.25753 13.1592 4.4487C12.8242 3.63986 12.3331 2.90493 11.7141 2.28587C11.095 1.66682 10.3601 1.17575 9.55124 0.840722C8.7424 0.50569 7.87549 0.333252 7.00001 0.333252ZM7.00001 12.3333C5.94518 12.3333 4.91403 12.0205 4.03697 11.4344C3.15991 10.8484 2.47632 10.0154 2.07266 9.0409C1.66899 8.06636 1.56337 6.994 1.76916 5.95944C1.97495 4.92487 2.4829 3.97456 3.22878 3.22868C3.97466 2.4828 4.92497 1.97485 5.95953 1.76906C6.9941 1.56328 8.06645 1.66889 9.04099 2.07256C10.0155 2.47623 10.8485 3.15982 11.4345 4.03688C12.0206 4.91394 12.3333 5.94509 12.3333 6.99992C12.3333 8.41441 11.7714 9.77096 10.7712 10.7712C9.77106 11.7713 8.4145 12.3333 7.00001 12.3333Z"
        fill={color}
      />
    </svg>
  );
}

ClockIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
